import { useAuth } from "@/hooks/use-auth";

/**
 * Client mirror of the two survey capabilities defined in
 * `server/lib/authorization.ts`:
 *
 * - `surveys` ("Admin de Pesquisas") — manage surveys **and** read the answers.
 * - `surveys_manager` ("Operador de Pesquisas") — create, edit, dispatch and
 *   follow participation; never the answer content.
 *
 * The gates here only keep the UI from firing requests that would 403 (a 403
 * raises the global "Sem permissão" toast). The server stays the source of
 * truth: it strips `answers` from the payload and reports `canViewResponses`
 * on each survey/instance detail, which is what the response UI must read.
 */
export function useSurveyAccess() {
  const { hasPermission } = useAuth();

  return {
    /** Can create, edit, dispatch and follow surveys. */
    canOperateSurveys: hasPermission("surveys") || hasPermission("surveys_manager"),
    /** Can read the answer content. */
    canViewSurveyResponses: hasPermission("surveys"),
  };
}
